import { ReactNode } from "react"

export const ScreenTemplate = ({ header, text, children }: { header: string, text?: string, children: ReactNode }) => {
    return (
        <div>
            <h1>{header}</h1>
            {!!text && (
                <p>
                    {text}
                </p>
            )}
            <hr />
            <div>
                {children}
            </div>
        </div>
    )
}